import moment from "moment";
import BookingEditView from "../BookingEditView/BookingEditView.vue";

export default {
  name: "BookingServicePackagesListTable",
  components: { BookingEditView },
  props: ["items", "isLoading", "count", "accommodationTypes", "featureGroups"],
  data: () => ({
    headers: [
      { text: "Name", value: "name" },
      { text: "Gastgeber", value: "serviceproviderName" },
      { text: "Stadt", value: "address.city" },
      { text: "Bundesland", value: "federalState" },
      { text: "Nächte", value: "nights" },
      { text: "Preis", value: "price" },
      { text: "GID", value: "gid" },
      { text: "Angebots-ID", value: "packageId" },
      { text: "Zuletzt geändert am", value: "updatedAt" },
      { text: "Aktionen", sortable: false, value: "actions" }
    ],
    localFilter: { limit: 10, skip: 0 },
    page: 1,
    itemsPerPage: 10,
    dialog: false,
    editedItem: {}
  }),
  mounted() {
    const itemsPerPage = Number(this.filter?.limit || this.itemsPerPage);
    if (itemsPerPage && !isNaN(itemsPerPage)) {
      this.localFilter.limit = itemsPerPage;
      this.localFilter.itemsPerPage = itemsPerPage;
      this.itemsPerPage = itemsPerPage;
    }
    const initialSkip = Number(this.filter?.skip);
    if (Number.isFinite(initialSkip) && initialSkip >= 0) {
      this.localFilter.skip = initialSkip;
    }
    const initialPage = Number(this.filter?.page);
    if (Number.isFinite(initialPage) && initialPage > 0) {
      this.page = initialPage;
    }
    this.localFilter.page = this.page;
  },
  methods: {
    buildRequestFilter(overrides = {}) {
      return {
        ...this.filter,
        ...this.localFilter,
        ...overrides
      };
    },
    async previousPage() {
      const limit = this.localFilter.limit || this.itemsPerPage;

      const { skip = 0 } = this.localFilter;
      const currentPage = Math.floor(skip / limit) + 1;

      if (currentPage > 1) {
        this.localFilter.skip = skip - limit;
        this.$emit("getItems", this.buildRequestFilter());
      }
    },
    async nextPage() {
      const limit = this.localFilter.limit || this.itemsPerPage;

      const totalPages = Math.ceil(this.count / limit);
      const { skip = 0 } = this.localFilter;
      const currentPage = Math.floor(skip / limit) + 1;

      if (currentPage < totalPages) {
        this.localFilter.skip = skip + limit;
        this.$emit("getItems", this.buildRequestFilter());
      }
    },
    getNiceDateTime(value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
    editItem(item) {
      this.dialog = true;
      this.editedItem = item;
    },
    closeDialog() {
      this.editedItem = {};
      this.dialog = false;
    },
    goToDetail(detailLink) {
      const url = `https://landsichten.de/gastgeber/${detailLink}`;
      window.open(url, "_blank");
    }
  },
  computed: {
    tableOptions: {
      get() {
        return {
          ...this.localFilter,
          page: this.localFilter.page || this.page,
          itemsPerPage: this.itemsPerPage
        };
      },
      async set(value) {
        if (!value || typeof value !== "object") return;
        if (!this.localFilter.isDefault) delete value.isDefault;

        const nextItemsPerPage = Number(value.itemsPerPage);
        const resolvedItemsPerPage =
          Number.isFinite(nextItemsPerPage) && nextItemsPerPage > 0
            ? nextItemsPerPage
            : this.itemsPerPage;
        const nextPage = Number(value.page);
        const resolvedPage =
          Number.isFinite(nextPage) && nextPage > 0 ? nextPage : this.page;
        const sort = value?.sortBy?.[0] ?? "start";
        const direction = value?.sortDesc?.[0] ? -1 : 1;
        const skip =
          resolvedPage > 1 ? (resolvedPage - 1) * resolvedItemsPerPage : 0;
        const currentPage = Number(this.localFilter.page || this.page || 1);
        const currentLimit = Number(
          this.localFilter.limit || this.itemsPerPage || 10
        );

        const hasChanged =
          resolvedPage !== currentPage ||
          resolvedItemsPerPage !== currentLimit ||
          sort !== this.localFilter.sort ||
          direction !== this.localFilter.direction;

        if (!hasChanged) return;

        this.page = resolvedPage;
        this.itemsPerPage = resolvedItemsPerPage;
        this.localFilter = {
          ...this.localFilter,
          limit: resolvedItemsPerPage,
          itemsPerPage: resolvedItemsPerPage,
          page: resolvedPage,
          skip,
          sort,
          direction
        };

        this.$emit("getItems", this.buildRequestFilter());
      }
    }
  }
};
